import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-stock",
  "use": "icon-stock-usage",
  "viewBox": "0 0 16 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 18\" class=\"icon\" id=\"icon-stock\">\r\n  \r\n  <path id=\"icon-stock_备货补货\" class=\"cls-1\" d=\"M43.3,443.936H34.692a0.51,0.51,0,0,1,0-1.02H43.3A0.51,0.51,0,0,1,43.3,443.936Zm0,4.572H34.692a0.51,0.51,0,0,1,0-1.02H43.3A0.51,0.51,0,0,1,43.3,448.508ZM39,453.08H34.692a0.51,0.51,0,0,1,0-1.019H39A0.51,0.51,0,0,1,39,453.08ZM43.959,457h-9.92A3.05,3.05,0,0,1,31,453.945V442.052a3.049,3.049,0,0,1,3.034-3.058h9.92a3.049,3.049,0,0,1,3.034,3.058v0.065a0.506,0.506,0,1,1-1.011,0v-0.065a2.033,2.033,0,0,0-2.023-2.039h-9.92a2.033,2.033,0,0,0-2.023,2.039v11.893a2.032,2.032,0,0,0,2.023,2.038h9.92a2.032,2.032,0,0,0,2.023-2.038v-6.222a0.506,0.506,0,1,1,1.011,0v6.222A3.05,3.05,0,0,1,43.959,457Zm2.529-11.1a0.508,0.508,0,0,1-.506-0.51v-1.412a0.506,0.506,0,1,1,1.011,0v1.412A0.507,0.507,0,0,1,46.487,445.9Z\" transform=\"translate(-31 -439)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/stock.svg
// module id = t+aG
// module chunks = 127